import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
import { LiveChatProvider } from '../../providers/live-chat/live-chat';
import * as debug from 'debug';

/**
 * Generated class for the KarmaMilesPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'onlineIndicator',
})
export class OnlineIndicatorPipe implements PipeTransform {
  log = debug('app:OnlineIndicatorPipe');

  constructor(public liveChat: LiveChatProvider) {}
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: string, ...args) {
    this.log('value', this.liveChat.onlineUserIds, value, args);
    return !!_.includes(this.liveChat.onlineUserIds, value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/online-indicator/online-indicator.ts